import { Box, Tab, Tabs } from "@mui/material";
import React, { FC, ReactElement, useEffect } from "react";
import { CB, Mask, MRPC, QNLI, RTE, WNLI, STSB } from "./components";

const Tests: FC = (): ReactElement => {
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `tests-tab-${index}`,
      "aria-controls": `tests-tabpanel-${index}`,
    };
  }

  useEffect(() => {
    return;
  });

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="perplexity tabs"
        >
          <Tab label="Mask" {...a11yProps(0)} />
          <Tab label="MRPC" {...a11yProps(1)} />
          <Tab label="STS-B" {...a11yProps(4)} />
          <Tab label="RTE" {...a11yProps(2)} />
          <Tab label="WNLI" {...a11yProps(3)} />
          <Tab label="QNLI" {...a11yProps(5)} />
          <Tab label="CB" {...a11yProps(6)} />
        </Tabs>
        <Mask tabValue={tabValue} index={0}></Mask>
        <MRPC tabValue={tabValue} index={1}></MRPC>
        <RTE tabValue={tabValue} index={2}></RTE>
        <WNLI tabValue={tabValue} index={3}></WNLI>
        <STSB tabValue={tabValue} index={4}></STSB>
        <QNLI tabValue={tabValue} index={5}></QNLI>
        <CB tabValue={tabValue} index={6}></CB>
      </Box>
    </>
  );
};

export default Tests;
